import { CheckerboardIcon } from './CheckerboardIcon';

/**
 * author: Austin Andrews
 * id A5F7D4AF-C7A3-4F38-B21B-B9F3E68770DE
 * name checkerboard
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkerboard.svg
 * tags
 * - Gaming / RPG 
 * - Geographic Information System 
 */
export const RasterIcon = CheckerboardIcon;
export default RasterIcon